export const LOGIN_SUCCESS = "USER/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "USER/LOGIN_FAILURE";
export const LOADING = "USER/LOADING";
export const LOGOUT = "USER/LOGOUT";
export const CURRENT = "USER/CURRENT";
